module.exports = __webpack_public_path__ + "img/Gerätewagen_Logistik_2.ee0e291a.svg";